const drawer = document.getElementById('quickViewDrawer');
  const drawerOverlay = document.getElementById('drawerOverlay');
  const drawerCloseBtn = document.getElementById('drawerCloseBtn');
  const altContainer = document.getElementById('altContainer');
  const spinner = document.getElementById('product-quick-view-spinner');
  const fullDetailsLink = document.getElementById('quickViewFullDetailsLink');
  const quickViewDrawer = document.getElementById('quickViewDrawer');

  let quickViewSizeChartModal = null;

  // Intercept sibling variant links inside Quick View (attach once).
  // Do NOT use `{ once: true }` because opening the size chart counts as a click
  // and would remove the handler, causing later sibling clicks to navigate to the PDP.
  if (altContainer && !altContainer.dataset.quickViewSiblingInterceptAttached) {
    altContainer.addEventListener('click', function (e) {
      const link = e.target.closest?.('a[href*="/products/"][class]');
      if (!link) return;

      const isSiblingVariant = link.classList.contains('product__sibling-variant');
      if (!isSiblingVariant && !link.href.includes('/products/')) return;

      e.preventDefault();
      e.stopPropagation();

      const productUrl = link.getAttribute('href');
      if (!productUrl) return;

      showSpinner();
      altContainer.innerHTML = "";
      setTimeout(() => {
        fetchProductData(productUrl, true);
      }, 0);
    });
    altContainer.dataset.quickViewSiblingInterceptAttached = 'true';
  }

  function moveSizeChartModalIntoQuickView() {
    if (!drawer || !quickViewDrawer) return;

    // The size chart DrawerModal is rendered inside the injected product HTML.
    // Move it under the quick view drawer so it behaves like part of the drawer UI.
    const modalsInAlt = altContainer
      ? Array.from(altContainer.querySelectorAll('#DrawerModal--size_chart'))
      : [];
    const modal =
      modalsInAlt[modalsInAlt.length - 1] ||
      quickViewDrawer.querySelector('#DrawerModal--size_chart') ||
      null;
    if (!modal) return;

    // Remove duplicates/stale content (there should only be one size chart modal).
    if (altContainer) {
      altContainer.querySelectorAll('#DrawerModal--size_chart').forEach((el) => {
        if (el !== modal) el.remove();
      });
    }
    quickViewDrawer.querySelectorAll('#DrawerModal--size_chart').forEach((el) => {
      if (el !== modal) el.remove();
    });

    // Ensure the modal is always a direct child of drawerContent, even if it is currently under another parent.
    if (modal.parentElement !== quickViewDrawer) quickViewDrawer.appendChild(modal);

    quickViewSizeChartModal = modal;
  }

  function cleanupQuickViewMovedModals() {
    if (quickViewSizeChartModal && quickViewSizeChartModal.parentNode) {
      quickViewSizeChartModal.parentNode.removeChild(quickViewSizeChartModal);
    } else if (quickViewDrawer) {
      quickViewDrawer.querySelector('#DrawerModal--size_chart')?.remove();
    }
    quickViewSizeChartModal = null;
  }

  function normalizeQuickViewHideSelectors(list) {
    if (!Array.isArray(list)) return [];
    return list
      .map((s) => (typeof s === 'string' ? s.trim() : ''))
      .filter(Boolean)
      .map((s) => {
        // Allow passing either a class name or a full selector.
        if (s.startsWith('.') || s.startsWith('#') || s.startsWith('[') || s.includes(' ') || s.includes('>') || s.includes(':')) return s;
        return `.${s}`;
      });
  }

  function getQuickViewHideSelectors() {
    const fromArray = window.BauerThemeConfig?.quickView?.hideInProductSubWrapper;
    if (Array.isArray(fromArray)) return normalizeQuickViewHideSelectors(fromArray);

    const raw = window.BauerThemeConfig?.quickView?.hideInProductSubWrapperRaw;
    if (typeof raw !== 'string') return [];
    // Allow: newline-separated, comma-separated, or mixed
    const parts = raw
      .split(/\r?\n/)
      .flatMap((line) => line.split(','))
      .map((s) => s.trim())
      .filter(Boolean);

    return normalizeQuickViewHideSelectors(parts);
  }

  function applyQuickViewHidesWithinAltContainer(root) {
    if (!root) return;

    const selectors = getQuickViewHideSelectors();
    if (!selectors.length) return;

    selectors.forEach((selector) => {
      root.querySelectorAll(selector).forEach((el) => {
        el.style.display = 'none';
      });
    });
  }

  function applyQuickViewHidesWithRetry(root, remainingTries = 20) {
    // In Quick View, `add-to-cart-sticky.js` (where the global config lives) can be injected dynamically.
    // Retry briefly so the config has time to load before we apply the hides.
    const selectors = getQuickViewHideSelectors();
    if (selectors.length) {
      applyQuickViewHidesWithinAltContainer(root);
      return;
    }
    if (remainingTries <= 0) return;
    setTimeout(() => applyQuickViewHidesWithRetry(root, remainingTries - 1), 100);
  }

  function normalizeQuickViewGallery(productSection) {
    if (!productSection) return;

    productSection.querySelectorAll('.product').forEach((product) => {
      product.classList.remove('product--stacked', 'product--thumbnail');
      product.classList.add('product--thumbnail_slider');
    });

    productSection.querySelectorAll('media-gallery').forEach((gallery) => {
      gallery.dataset.presentation = 'carousel';
      gallery.dataset.desktopLayout = 'dots';
      gallery.dataset.desktopPagination = 'dots';
      gallery.dataset.thumbnailPosition = 'bottom';
      gallery.dataset.mobileBehavior = 'carousel';
      gallery.dataset.mobilePagination = 'dots';
    });

    productSection.querySelectorAll('[id^="GalleryThumbnails"]').forEach((thumbnailSlider) => {
      thumbnailSlider.setAttribute('hidden', 'hidden');
    });

    productSection.querySelectorAll('.product-media-modal__content img, media-gallery img').forEach((image) => {
      image.loading = 'eager';
      image.setAttribute('fetchpriority', 'high');
    });
  }

  function selectQuickViewModalMedia(thumbnail) {
    const modal = thumbnail.closest('product-modal');
    if (!modal) return;

    activateQuickViewModalMedia(modal, thumbnail.getAttribute('data-media-id'), thumbnail);
  }

  function primeQuickViewModalImages(activeMedia) {
    if (!activeMedia) return;

    const images = activeMedia.matches('img')
      ? [activeMedia]
      : Array.from(activeMedia.querySelectorAll('img'));

    images.forEach((image) => {
      image.loading = 'eager';
      image.removeAttribute('loading');

      if (image.complete) return;

      const src = image.currentSrc || image.src;
      if (!src) return;

      const preload = new Image();
      preload.src = src;
      preload.addEventListener('load', () => {
        image.dispatchEvent(new Event('load'));
      }, { once: true });
    });
  }

  function applyQuickViewModalActiveState(modal, activeMedia, activeThumbnail = null) {
    if (!modal || !activeMedia) return;

    const mediaItems = Array.from(modal.querySelectorAll('[role="document"] [data-media-id]'));
    mediaItems.forEach((item) => {
      item.classList.toggle('active', item === activeMedia);
    });

    const activeMediaId = activeMedia.getAttribute('data-media-id');
    modal.querySelectorAll('[data-modal-media-thumb]').forEach((thumb) => {
      const isActive = activeThumbnail
        ? thumb === activeThumbnail
        : thumb.getAttribute('data-media-id') === activeMediaId;
      thumb.classList.toggle('is-active', isActive);
      if (isActive) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });

    primeQuickViewModalImages(activeMedia);

    const container = modal.querySelector('[role="document"]');
    if (!container) return;

    scrollQuickViewModalMediaIntoView(container, activeMedia);
  }

  function resolveQuickViewModalMedia(modal, mediaId) {
    if (!modal) return null;

    const mediaItems = Array.from(modal.querySelectorAll('[role="document"] [data-media-id]'));
    if (!mediaId) return mediaItems[0] || null;

    return (
      modal.querySelector(`[role="document"] [data-media-id="${mediaId}"]`) ||
      mediaItems.find((item) => item.getAttribute('data-media-id') === mediaId) ||
      null
    );
  }

  function activateQuickViewModalMedia(modal, openerOrMediaId, activeThumbnail = null) {
    const mediaId = typeof openerOrMediaId === 'string'
      ? openerOrMediaId
      : openerOrMediaId?.getAttribute('data-media-id');
    const activeMedia = resolveQuickViewModalMedia(modal, mediaId);
    if (!activeMedia) return;

    applyQuickViewModalActiveState(modal, activeMedia, activeThumbnail);
    return activeMedia;
  }

  function getQuickViewModalMediaFrame(activeMedia) {
    return (
      activeMedia.querySelector('.product__media img, .media img, .deferred-media__poster img') ||
      (activeMedia.matches('img') ? activeMedia : null) ||
      activeMedia
    );
  }

  function scrollQuickViewModalMediaIntoView(container, activeMedia) {
    const scrollToActiveMedia = () => {
      const mediaFrame = getQuickViewModalMediaFrame(activeMedia);
      const containerRect = container.getBoundingClientRect();
      const mediaRect = mediaFrame.getBoundingClientRect();

      // Top of image at top of viewport; image centered horizontally (top-middle).
      const scrollTop = container.scrollTop + (mediaRect.top - containerRect.top);
      const scrollLeft =
        container.scrollLeft +
        (mediaRect.left - containerRect.left) +
        mediaRect.width / 2 -
        containerRect.width / 2;

      const maxTop = Math.max(0, container.scrollHeight - container.clientHeight);
      const maxLeft = Math.max(0, container.scrollWidth - container.clientWidth);

      container.scrollTo({
        top: Math.max(0, Math.min(scrollTop, maxTop)),
        left: Math.max(0, Math.min(scrollLeft, maxLeft)),
        behavior: 'auto',
      });
    };

    requestAnimationFrame(() => {
      scrollToActiveMedia();

      const image = activeMedia.matches('img') ? activeMedia : activeMedia.querySelector('img');
      if (!image || image.complete) return;

      image.loading = 'eager';
      image.addEventListener('load', () => {
        requestAnimationFrame(scrollToActiveMedia);
      }, { once: true });
    });
  }

  function patchProductModalForQuickView() {
    const ModalClass = customElements.get('product-modal');
    if (!ModalClass || ModalClass.__quickViewPatched) return;

    const originalShow = ModalClass.prototype.show;

    ModalClass.prototype.show = function(opener) {
      originalShow.call(this, opener);
      if (!drawer?.contains(this)) return;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          activateQuickViewModalMedia(this, opener);
        });
      });
    };

    const originalCapture = ModalClass.prototype.onModalPointerUpCapture;
    ModalClass.prototype.onModalPointerUpCapture = function(event) {
      if (!drawer?.contains(this)) {
        if (typeof originalCapture === 'function') originalCapture.call(this, event);
        return;
      }

      if (event.pointerType !== 'mouse') return;
      if (event.target.closest('[data-modal-media-thumb]')) {
        event.stopPropagation();
      }
    };

    ModalClass.__quickViewPatched = true;
  }

  function bindQuickViewModalThumbnails(modal) {
    if (!modal) return;

    modal.querySelectorAll('[data-modal-media-thumb]').forEach((thumbnail) => {
      if (thumbnail.dataset.qvBound === 'true') return;
      thumbnail.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        selectQuickViewModalMedia(thumbnail);
      });
      thumbnail.dataset.qvBound = 'true';
    });
  }

  function showSpinner() {
    spinner.classList.remove('hidden');
    setTimeout(() => {
      spinner.classList.add('show');
    }, 10);
  }

  function hideSpinner() {
    spinner.classList.remove('show');
    setTimeout(() => {
      spinner.classList.add('hidden');
    }, 300);
  }

  function openDrawer() {
    drawer.classList.remove('hidden');
    drawerOverlay.style.display = 'block';
    setTimeout(() => {
      drawer.classList.add('show');
    }, 10);
  }

  function closeDrawer() {
    drawer.classList.remove('show');
    setTimeout(() => {
      drawer.classList.add('hidden');
      cleanupQuickViewMovedModals();
      altContainer.innerHTML = ""; // Optional: clear content on close
      if (fullDetailsLink) {
        fullDetailsLink.style.display = 'none';
        fullDetailsLink.href = '#';
      }
    }, 300);
  }

  // Close on overlay click
  drawerOverlay.addEventListener('click', closeDrawer);

  // Close on close button
  drawerCloseBtn.addEventListener('click', closeDrawer);

  // You may want to add this too to allow ESC key to close the drawer
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeDrawer();
    }
  });
  window.addEventListener('quickViewClick', (e) => {
    const { productUrl, productName } = e.detail;
    // Perform any additional actions here
});
// Attach listener once DOM is ready
window.addEventListener('ssQuickViewClick', (e) => {
    const handle = e?.detail?.productUrl;
    if (!handle) return;

    fetchProductData(handle);
    openDrawer();
});

drawer.addEventListener('click', function(e) {
  const modalThumbnail = e.target?.closest('[data-modal-media-thumb]');
  if (!modalThumbnail) return;

  e.preventDefault();
  e.stopPropagation();
  selectQuickViewModalMedia(modalThumbnail);
}, true);

drawer.addEventListener('pointerup', function(e) {
  if (e.target?.closest('[data-modal-media-thumb]')) {
    e.stopPropagation();
  }
}, true);

// For dynamically loaded content, use event delegation from the drawer
drawer.addEventListener('click', function(e) {
  const target = e.target;
  if (target && (target.classList.contains('product-form__submit') || 
     (target.closest('.product-form__submit') && 
      (target.closest('.product-form__submit').name === 'add' || 
       target.closest('.product-form__submit').textContent.trim().toLowerCase().includes('add'))))) {
    
    setTimeout(() => {
      closeDrawer();
    }, 1000);
  }

  if(target && target.classList.contains('product__media-toggle')) {
    // Toggle the class for modal behavior when media is clicked
    const modal = document.querySelector('#drawerContent');
    console.log(modal);
    console.log("drawerContent");
  }
});

// Your existing fetchProductData function
// Track ongoing fetches to prevent duplicates
const pendingFetches = new Map();
async function fetchProductData(handle, load = false) {
  // If there's already a fetch in progress for this handle, return the existing promise
  if (pendingFetches.has(handle)) {
    console.log(`🔄 Already fetching product data for: ${handle}`);
    return pendingFetches.get(handle);
  }

  console.log("🚨 Fetching product data for handle:", handle, "load:", load);
  const url = `${window.location.origin}${handle}`;
  showSpinner();

  // Update the "View Full Details" link with the product URL
  if (fullDetailsLink) {
    fullDetailsLink.href = handle;
    fullDetailsLink.style.display = 'block';
  }
  // Create a new promise for this fetch and store it
  const fetchPromise = (async () => {
    try {
      const res = await fetch(url);
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const productSection = doc.querySelector('.shopify-section.product-section.spaced-section');

      const loadedScripts = window._quickViewLoadedScripts || (window._quickViewLoadedScripts = new Set());
      if(!load) {
        productSection.querySelectorAll('script').forEach(script => {
          // Only append executable scripts (skip JSON-LD and other data scripts)
          if (script.type && script.type !== "text/javascript" && script.type !== "") {
            return;
          }
          let scriptId = script.src ? script.src : script.textContent.trim();
          if (loadedScripts.has(scriptId)) {
            console.log(`Script already loaded: ${scriptId}`);
            return; // Skip if already loaded
          }
          loadedScripts.add(scriptId);

          const newScript = document.createElement('script');
          if (script.src) {
            newScript.src = script.src;
            newScript.async = script.async;
            newScript.defer = script.defer;
          } else {
            newScript.textContent = script.textContent;
          }
          
          document.body.appendChild(newScript);
        });
      }

      // Extract product variant count
      

      normalizeQuickViewGallery(productSection);
      if(await !addInnerHTML(productSection, altContainer, url)) return;
      
      
      if (productSection) {
          productSection.querySelectorAll('.slider.slider--mobile').forEach(el => {
            el.classList.remove('slider--mobile');
            el.classList.add('slider--everywhere');
          });
        if (window.innerWidth >= 1024) {
          productSection.classList.add('force-mobile-style-on-quick-view');
        }
        // Re-initialize the slider after changing the class
        altContainer.innerHTML = productSection.outerHTML;

        // Ensure the size chart drawer modal lives under the quick view drawer
        moveSizeChartModalIntoQuickView();

        if (!load) {
          if (!customElements.get('product-modal')) {
            class ProductModal extends ModalDialog {
              constructor() {
                super();
                this.addEventListener('pointerup', this.onModalPointerUpCapture.bind(this), true);
              }

              onModalPointerUpCapture(event) {
                if (event.pointerType !== 'mouse') return;
                if (event.target.closest('[data-modal-media-thumb]')) {
                  event.stopPropagation();
                }
              }

              show(opener) {
                super.show(opener);
                if (!drawer?.contains(this)) return;

                bindQuickViewModalThumbnails(this);
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => {
                    const activeMedia = activateQuickViewModalMedia(this, opener);
                    if (!activeMedia) return;

                    const activeMediaTemplate = activeMedia.querySelector('template');
                    const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

                    if (activeMedia.nodeName !== 'DEFERRED-MEDIA') return;

                    const hasExternalVideo = activeMediaContent && (activeMediaContent.querySelector('.js-youtube') || activeMediaContent.querySelector('.js-vimeo'));
                    const hasRegularVideo = activeMediaContent?.querySelector('video');
                    if (!hasExternalVideo && !hasRegularVideo) return;

                    activeMedia.loadContent();

                    if (!hasRegularVideo) return;

                    const isMobile = window.innerWidth <= 749 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                    const checkVideo = setInterval(() => {
                      const video = activeMedia.querySelector('video');
                      if (!video) return;

                      clearInterval(checkVideo);
                      if (isMobile) {
                        video.autoplay = true;
                        if (video.paused) video.play().catch(() => {});
                      } else {
                        video.autoplay = false;
                        if (!video.paused) video.pause();
                      }
                    }, 50);
                    setTimeout(() => clearInterval(checkVideo), 2000);
                  });
                });
              }
            }

            customElements.define('product-modal', ProductModal);
          }

          patchProductModalForQuickView();
        }

        altContainer.querySelectorAll('product-modal').forEach((modal) => {
          bindQuickViewModalThumbnails(modal);
          modal.querySelectorAll('.product-media-modal__content img').forEach((image) => {
            image.loading = 'eager';
            image.setAttribute('fetchpriority', 'high');
          });
        });

        // Hide the product__sub-wrapper containing store locator in quick view
        const storeLocatorWrapper = altContainer.querySelector('.product__info-container .product__sub-wrapper .product__store_locator')?.closest('.product__sub-wrapper');
        if (storeLocatorWrapper) {
          storeLocatorWrapper.style.display = 'none';
        }

        // Hide configured elements inside `.product__sub-wrapper` (Quick View only)
        applyQuickViewHidesWithRetry(altContainer);

      } else {
        altContainer.innerHTML = "<p>Product section not found.</p>";
      }
    } catch (err) {
      hideSpinner();
      console.error("🚨 Error during fetchProductData:", err);
      altContainer.innerHTML = "<p>Product Not Found</p>";
    } finally {
      // Remove this handle from pending fetches when done
      pendingFetches.delete(handle);
    }
  })();

  // Store the promise for this handle
  pendingFetches.set(handle, fetchPromise);
  
  // Return the promise
  return fetchPromise;
}

async function addInnerHTML(productSection, altContainer, url) {
  const variantCount = productSection.querySelector('variant-selects, variant-radios')?.querySelectorAll('option, input[type="radio"]')?.length || 0;

  if(variantCount > 1) {
    altContainer.innerHTML = productSection.outerHTML;
    hideSpinner();
    return true;
  } else {
    altContainer.innerHTML = productSection.outerHTML;
    await addToCartSS(url);
    return false;
  }
}

async function addToCartSS(url) {
  const productUrl = new URL(url);
    const productResponse = await fetch(`${productUrl.origin}${productUrl.pathname}.js`);
    if (productResponse.ok) {
      const productData = await productResponse.json();
      // If product has only one variant and no options, add to cart directly
      if (productData.variants.length === 1 && 
          (!productData.options || productData.options.every(option => option.values.length <= 1))) {
        try {
            const quickViewProductForm = document.querySelector('product-form');
            if (quickViewProductForm && quickViewProductForm.onSubmitHandler) {
              quickViewProductForm.onSubmitHandler(new Event('submit'));
              hideSpinner();
              closeDrawer();
            }
        } catch (addError) {
          console.error("Error adding product to cart:", addError);
        }
      }
    } else {
      console.error("Error fetching product data:", productResponse.statusText);

    }
}
